import React from 'react';
import { Form } from 'antd';
import { FormInstance } from 'antd/lib/form';
import WizardForm from '@severalnines/bar-frontend-components/build/lib/Navigation/WizardForm';
import WizardFormConfiguration from '@severalnines/bar-frontend-components/build/lib/Navigation/Wizard/WizardFormConfiguration';
import CcCluster from '../../../../services/models/CcCluster';
import ImportPgBouncerAuthentication from './ImportPgBouncerWizardSteps/ImportPgBouncerAuthentication';
import ImportPgBouncerAddNodes, {
    getImportPgBouncerAddNodesValidation,
    PGBOUNCER_NODES_INITIAL,
} from './ImportPgBouncerWizardSteps/ImportPgBouncerAddNodes';
import ImportPgBouncerPreview from './ImportPgBouncerWizardSteps/ImportPgBouncerPreview';
import useCreateJob from '../../../Jobs/useCreateJob';
import { CmonJobInstanceCommand } from '../../../../services/cmon/models/CmonJobInstance';

enum PgBouncerFormSteps {
    AUTHENTICATION = 'Authentication',
    ADD_NODES = 'Add nodes',
    PREVIEW = 'preview',
}

export type ImportPgBouncerWizardFormProps = {
    onCancel?: () => void;
    onSuccess?: () => void;
    onError?: (err: Error) => void;
    onStepErrorInsist?: (err: Error) => void;
    onTouchedChange?: (touched: boolean) => void;
    cluster?: CcCluster;
};
export default ImportPgBouncerWizardForm;

function ImportPgBouncerWizardForm({
    onCancel,
    onSuccess,
    onStepErrorInsist,
    onTouchedChange,
    onError,
    cluster,
}: ImportPgBouncerWizardFormProps) {
    const [form] = Form.useForm();

    const { loading, send } = useCreateJob({
        clusterId: cluster?.clusterId,
        title: "PgBouncer 'register' Job",
        command: CmonJobInstanceCommand.PGBOUNCER.toLowerCase() as CmonJobInstanceCommand,
        onSuccess,
    });

    const handleSubmit = async () => {
        try {
            await send({
                clusterId: cluster?.clusterId,
                ...formatFields(form),
            });
        } catch (err: any) {
            if (onError) {
                onError(err);
            }
        }
    };
    return (
        <WizardFormConfiguration
            form={form}
            onSubmit={handleSubmit}
            loading={loading}
            onCancel={onCancel}
            onStepErrorInsist={onStepErrorInsist}
            onTouchedChange={onTouchedChange}
            initialValues={{
                ...PGBOUNCER_NODES_INITIAL,
            }}
            steps={[
                <WizardForm.Step
                    key={PgBouncerFormSteps.AUTHENTICATION}
                    title="Authentication"
                    subTitle=" "
                >
                    <ImportPgBouncerAuthentication />
                </WizardForm.Step>,
                <WizardForm.Step
                    key={PgBouncerFormSteps.ADD_NODES}
                    title="Add nodes"
                    subTitle=" "
                    validate={getImportPgBouncerAddNodesValidation(form)}
                >
                    <ImportPgBouncerAddNodes form={form} cluster={cluster} />
                </WizardForm.Step>,

                <WizardForm.Step
                    key={PgBouncerFormSteps.PREVIEW}
                    title="Preview"
                    subTitle=" "
                >
                    <ImportPgBouncerPreview form={form} />
                </WizardForm.Step>,
            ]}
        />
    );
}

export function formatFields(form: FormInstance) {
    const { pgBouncerAuth, pgBouncerAddNodes } = form.getFieldsValue(true);

    return {
        action: 'register',
        nodes: pgBouncerAddNodes?.hostname?.map((data: any) => {
            const hostname = data?.extraData.hostname;
            return {
                class_name: 'CmonPgBouncerHost',
                hostname,
                port: pgBouncerAddNodes?.listenPort,
            };
        }),
        admin_username: pgBouncerAuth?.adminUser,
        admin_password: pgBouncerAuth?.adminPassword,
    };
}
